import React from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

import { SimpleButton } from '@ubiwherenpm/adene-ui-components'

export default class ButtonConfirm extends React.Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)

    let item = (props.value !== undefined && props.value !== null) ? {value: props.value} : this.getFirstSelectedItem()

    this.state = {
      selected: item.value
    }
  }

  componentWillMount () {
    let item = (this.props.value !== undefined && this.props.value !== null) ? {value: this.props.value} : this.getFirstSelectedItem()

    if (this.props.onButtonClick) {
      this.props.onButtonClick({...item, first: true})
    }
  }

  getFirstSelectedItem () {
    this.props.items &&
    this.props.items.forEach((item) => {
      if (item.status) return item
    })
    return this.props.items && this.props.items[0]
  }

  handleClick (e) {
    if (this.props.onButtonClick) {
      this.props.onButtonClick({...e})
    }
    this.setState({
      selected: e.value
    })
  }

  render () {
    const { items } = this.props

    return (
      <Container>
        {items && items.map(({ value, text, status }) => {
          return (
            <Button
              key={`buttonconfirm-${value}${text}`}
              onClick={(e) => { this.handleClick({value}) }}
              value={value}
              bgColor={backgroundColors.normalRight}
              status={this.state.selected === value}
            >
              {text}
            </Button>
          )
        })}
      </Container>
    )
  }
}

const Button = styled(SimpleButton)`
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  margin: 0;

  margin-left: 41px;

  font-family: 'Nunito', 'Helvetica Neue', sans-serif;
  text-transform: uppercase;
  color: #010101;
  font-size: 24px;
  font-weight: bold;
  line-height: 24px;
  letter-spacing: 1px;

  text-align: center;
  padding: 28px 0px 28px 0px;

  -webkit-transtion: none;
  -moz-transition: none;
  -ms-transition: none;
  transition: none;

  min-width: 80px;
  display: inline-block;
  background: transparent;

  outline: none;
  cursor: pointer;
  border-radius: 0px;

  &:hover {
    color: #FFFFFF;
    outline: none;
    background: ${({bgColor}) => bgColor};
  }

  ${({status, bgColor}) => status && `
    background: ${bgColor};
    color: #FFFFFF;
    border: none;
  `}

  &:focus {
    ${({status}) => status && `
      color: #FFFFFF;
    `}
    outline: none;
  }

  &:first-child{
    margin-left: 0px;
  }
`

const Container = styled.div`
  width: auto;
  display: inline-block;
  margin-top: 32px;
`



// WEBPACK FOOTER //
// ./src/components/ButtonConfirm/index.js